<template>
  <div>
    <nav class="columns is-vcentered cc-navbar-columns" role="navigation">
      <div class="column is-narrow-mobile">
          <div class="columns is-gapless is-vcentered is-mobile column is-narrow">
              <figure class="image is-32x32 mr-2">
                <img class="" src="@/assets/cc-logo.png" alt="ClimaCheck Online Logo">
              </figure>
            <div class="column is-narrow">
              <span class="is-size-1 has-text-weight-bold cc-has-text-blue">
              ClimaCheck
              </span>
            </div>
          </div>
      </div>
    </nav>
    <router-view/>
    <ccError ref="ccError"></ccError>
    <ccLoading ref="ccLoading"></ccLoading>
    <div class="columns is-centered">
      <footer>
        <span class="is-size-7 has-text-cc-blue" href="#/">
          <p>Copyright © ClimaCheck Sweden AB {{ this.currentYear }} <a href="https://media.home.climacheck.com/2018/05/We-have-your-contact-info-GDPR_2018-05-25.pdf">GDPR</a></p>
        </span>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  name: 'App',
  data () {
    return {
      currentYear: new Date().getFullYear(),
      selectedLocale: 'en'
    }
  },
  computed: {},
  mounted () {},
  watch: {},
  methods: {}
}
</script>
